<template>
    <div class="container">
        <b-container fluid v-if="!showPage">
              <b-row>
                <div class="text-center m-5">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>&nbsp;Loading...</strong>
                </div>
              </b-row>
        </b-container>   
        <b-container fluid v-if="showPage" style="margin-top:100px;">
            <b-row style="margin-top:100px;text-align: left;">
                    <b-col>
                        <h3>Projects and runs</h3>
                    </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <hr>
                </b-col>
            </b-row>
            <b-row style="text-align: left;" v-show="projHtmlTxt.length >=1">
                <b-col>
                    <div id="boxBg">
                        <span v-html="projHtmlTxt"></span>
                    </div>
                </b-col>
            </b-row>
            <b-row style="text-align: left;">
                <b-col>
                    <br>
                    <h3>Projects</h3>
                </b-col>
            </b-row>
            <b-row style="text-align: left;">
                <b-col>
                    <hr>
                    <b-row>
                        <b-col style="align:left">                       
                                <b-input-group>
                                    <b-form-input
                                    v-model="filter"
                                    type="search"
                                    id="filterHmPairs"
                                    placeholder="Type to Search"
                                    ></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                        </b-col>
                    </b-row>
                    <b-row style="align:left">
                        <b-col>
                        <b-form-group 
                            label="Filter options"
                            label-for="filt-input">
                            <b-input-group>
                                <b-form-select v-model="filtMod" :options="filtOptions"></b-form-select>
                                <b-form-input id="filt-input" v-model="filtTerm"></b-form-input>
                                <b-button variant="outline-primary" @click="addFilter">Add</b-button>
                            </b-input-group>
                            </b-form-group>
                            <div class="d-inline-block">                            
                            <ul>
                                <li v-for="(btn, idx) in addedFilters"
                                :key="idx" class="listyle">{{filtMap[btn.split(':')[0]]+':'+btn.split(':')[1]}} <a @click="removeFilter(btn)"><font-awesome-icon icon="window-close" size='sm'></font-awesome-icon></a> </li>
                            </ul>
                            </div>
                            <p>
                                <b>Note:</b>
                                The search box can be used to search eMGE ID, cluster ID of the samples only.
                            </p>
                            <p><download-csv
                            :data   = "procSams" style="cursor: pointer;">
                        To download the filtered table data in CSV format: &nbsp;
                        <font-awesome-icon icon="download" ></font-awesome-icon>
                        </download-csv></p>
                        </b-col>                        
                    </b-row>
                </b-col>
            </b-row>            
            <br/>
            <b-row>
                <b-col align-self="center">
                    <b-table
                                responsive
                                show-empty
                                :busy.sync="isBusy"
                                :striped="false"
                                :outlined="true"
                                :items="procSams"
                                :fields="tab_fields"
                                :current-page="currentPage"
                                :per-page="perPage"
                                :filter="filter"
                                :filter-function="filterTable"
                            >
                            <template  v-slot:table-busy>
                                      <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                      </div>
                            </template>
                            <template v-slot:cell(NCBIProjectID) ="row">
                                <router-link :to="{ path: '/viewproject/'+row.item.NCBIProjectID.trim()}" target="_blank" v-b-tooltip.hover title="View Project details in our database">{{row.item.NCBIProjectID.trim()}} <font-awesome-icon icon="link" size='sm'></font-awesome-icon></router-link>
                                <b-badge id="badge-tar" variant="primary"><a v-bind:href="'https://www.ncbi.nlm.nih.gov/bioproject/' + row.item.NCBIProjectID.trim()" target="_blank" style="color:white">NCBI <font-awesome-icon icon="external-link-alt" size='sm'></font-awesome-icon></a></b-badge>
                            </template>
                            <template v-slot:cell(OriginalProjectDescription)="row">
                                <read-more more-str="read more" :text="row.item.OriginalProjectDescription" link="#" less-str="read less" :max-chars="150" style="text-align:justify"></read-more>
                            </template>
                    </b-table>
                    <b-row>
                            <b-col md="6" class="my-1">
                                <b-pagination
                                v-model="currentPage"
                                :total-rows="procSamsSize"
                                :per-page="perPage"
                                class="my-0"
                                ></b-pagination>
                            </b-col>
                            <b-col md="6" class="my-1">
                                <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                                <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import axios from 'axios'
const _ = require("underscore")

export default {
    data () {
        return{
            server_add:"https://mai.fudan.edu.cn/",
            showPage:false,
            filter:null,
            isBusy:true,
            tab_data:[],
            tab_fields:[
                // { key:'MGEs_id',label:'MGE ID',sortable:false },
                { key: 'NCBIProjectID', label: 'Project ID', sortable: false ,'class': 'medium_col'},
                { key: 'NumberOfSamples', label: 'No. of samples', sortable: true},
                { key: 'NumberOfRuns', label: 'No. of runs', sortable: false},
                { key: 'Country', label: 'Country', sortable: true},
                { key: 'RelatedDisease', label: 'Related disease', sortable: false},
                { key: 'OriginalProjectDescription', label: 'Description', sortable: false},
                // { key: 'completeness', label: 'Completeness', sortable: false},
                // { key: 'genome_quality', label: 'Quality', sortable: false},
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 15,
            pageOptions: [5, 10, 15,25],
            projHtmlTxt:'',
            filtMod:'Country',
            filtTerm:'',
            filtOptions:['Country','Related disease'],
            filtMap:{'Country':'Country','RelatedDisease':'Related disease','Related disease':'RelatedDisease'},
            addedFilters:[],
        }
    },
    mounted() {
        this.loadDesc()
        this.loadProjTab()
    },
    computed: {
        procSams(){
            if(this.tab_data.length){
                let tem = this.tab_data.filter(sam =>{
                    var hasAss = false
                    if(this.filter != null && this.filter.length>=1){
                        // console.log(filter)
                        var sup = this.filter                                        
                        if( (sam.NCBIProjectID != null && sam.NCBIProjectID.match(sup)) || 
                            (sam.Country != null && sam.Country.match(sup)) || 
                            (sam.RelatedDisease != null && sam.RelatedDisease.match(sup)) ){
                            hasAss = true
                        }
                    }else{
                        hasAss = true
                    }
                    if(this.addedFilters.length>=1){
                        var su = 0
                        this.addedFilters.forEach(ele => {
                            var sp = ele.split(':')
                            if(sp != null  && sam[sp[0]] != null && sam[sp[0]].toLowerCase().match(sp[1].toLowerCase())){
                               su++ 
                            }
                        });
                        return hasAss && su === this.addedFilters.length
                    }else{
                        return hasAss && true
                    }
                })
                return tem
            }
            return null
        },
        procSamsSize(){
            if(this.tab_data.length){
                let tem = this.tab_data.filter(sam =>{
                    var hasAss = false
                    if(this.filter != null && this.filter.length>=1){
                        // console.log(filter)
                        var sup = this.filter                                        
                        if( (sam.NCBIProjectID != null && sam.NCBIProjectID.match(sup)) || 
                            (sam.Country != null && sam.Country.match(sup)) || 
                            (sam.RelatedDisease != null && sam.RelatedDisease.match(sup)) ){
                            hasAss = true
                        }
                    }else{
                        hasAss = true
                    }
                    if(this.addedFilters.length>=1){
                        var su = 0
                        this.addedFilters.forEach(ele => {
                            var sp = ele.split(':')
                            if(sp != null  && sam[sp[0]] != null && sam[sp[0]].toLowerCase().match(sp[1].toLowerCase())){
                               su++ 
                            }
                        });
                        return hasAss && su === this.addedFilters.length
                    }else{
                        return hasAss && true
                    }
                })
                return tem.length
            }
            return 0
        }
    },
    methods: {
        loadProjTab(){
            axios.post(this.server_add+'query/listProj',
            {
            }).then(retDat => {
                if(retDat.status == 200){
                    this.tab_data = retDat.data
                    this.showPage = true
                    this.isBusy = false
                    this.totalRows = this.tab_data.length
                }
            }).catch(err => {
                console.log(err)
            })
        },
        filterTable(row,filter) {
            var hasAss = false
            if(filter.includes(row.NCBIProjectID) || filter.includes(row.Country) || filter.includes(row.RelatedDisease)){
                hasAss = true
            }
            if(filter != null ){
                var su = filter.trim()
                if( (row.NCBIProjectID != null && row.NCBIProjectID.match(su)) || 
                (row.Country != null && row.Country.match(su)) || 
                (row.RelatedDisease != null && row.RelatedDisease.match(su)) ){
                  hasAss = true
                }
            }
            return hasAss;            
        },
        loadDesc(){
            axios.post(this.server_add+'query/getPageCont',
            {
                route:'projects'
            }).then(retDat => {                
                if(retDat.status === 200){
                    var res = retDat.data
                    var grp = _.groupBy(res,'regKey')
                    this.projHtmlTxt = grp['projp1'][0]['content'].replace('NA','')
                }
            }).catch(err => {
                console.log(err)
            })
        },
        addFilter(){
            var filtType = this.filtMap[this.filtMod]
            var filtText = this.filtTerm
            var res = filtType+":"+filtText
            if(!this.addedFilters.includes(res)){
                this.addedFilters.push(res)
                this.filtTerm = ''
            }
        },
        removeFilter(term){
            var ind = this.addedFilters.indexOf(term)
            if(ind >-1){
                this.addedFilters.splice(ind, 1);
            }
        },
    },
}
</script>

<style lang="less">
    #boxBg{
    background-color: #ECE9E9;
    padding-top: 10px;
    padding-bottom: 5px;
    padding-left: 5px;
    align-content: left;
    color: black;
}

.medium_col{
  width: 160px !important;
  height: 25px !important;
  max-height: 25px !important;
  max-width: 160px !important;
  text-align: center;
}
</style>